import aggregatedSales from './aggregatedSales';
import clients from './clients';
import sales from './sales';
import bills from './bills';
import fees from './fees';
import warehouses from './warehouses';
import excises from './excises';
import checkExportFlag from './checkExportFlag';
import helsedir from './helsedir';
import infinitum from './infinitum';
import excisePeriods from './excisePeriods';
import showExcisePeriod from './showExcisePeriod';
import closeExcisePeriod from './closeExcisePeriod';
import warehouseTransactions from './warehouseTransactions';
import downloadTurnOverPdf from './downloadTurnOverPdf';
import sendTurnOverPdf from './sendTurnOverPdf';
import exciseCalendar from './exciseCalendar';

export default {
  aggregatedSales,
  clients,
  sales,
  bills,
  fees,
  warehouses,
  excises,
  checkExportFlag,
  helsedir,
  infinitum,
  excisePeriods,
  showExcisePeriod,
  closeExcisePeriod,
  warehouseTransactions,
  downloadTurnOverPdf,
  exciseCalendar,
  sendTurnOverPdf,
};



// WEBPACK FOOTER //
// ./src/app/services/report/index.js